export default {
  getImpression: (state) => state.impression,
};
